// export const API_BASE_URL = 'http://localhost:8000/api/v1';
export const API_BASE_URL = 'https://akfintaxadvisors.com/api/v1';
// export const API_BASE_URL = 'https://akfintaxadvisors.com/apidev/v1';
